import { render, staticRenderFns } from "./livetv.vue?vue&type=template&id=fcb41d56&scoped=true&lang=pug&"
import script from "./livetv.vue?vue&type=script&lang=js&"
export * from "./livetv.vue?vue&type=script&lang=js&"
import style0 from "./livetv.vue?vue&type=style&index=0&id=fcb41d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb41d56",
  null
  
)

export default component.exports